/** Messages exchanged between the download manager and the download worker. */

export interface DownloadFileSpec {
  /** OPFS file name inside the item's folder. */
  name: string;
  url: string;
  /** Expected size from ABS metadata (0 when unknown). */
  size: number;
}

export type ToWorker =
  | { type: 'start'; jobId: string; itemId: string; /** OPFS folder inside `downloads/`. */ folder: string; files: DownloadFileSpec[]; authHeader: string }
  | { type: 'cancel'; jobId: string };

export type FromWorker =
  | { type: 'progress'; jobId: string; fileIndex: number; fileBytes: number; totalBytes: number }
  | { type: 'file-done'; jobId: string; fileIndex: number; bytes: number }
  | { type: 'done'; jobId: string }
  | { type: 'error'; jobId: string; message: string; status?: number; quota?: boolean; cancelled?: boolean };

export const DOWNLOADS_DIR = 'downloads';
